import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger, DialogFooter } from "@/components/ui/dialog";
import { Plus, User, Trash } from "@phosphor-icons/react";
import { toast } from "sonner";

export default function Mandanten() {
  const [rows, setRows] = useState([]);
  const [open, setOpen] = useState(false);
  const [saving, setSaving] = useState(false);
  const [form, setForm] = useState({
    vorname: "", nachname: "", email: "", telefon: "",
    strasse: "", plz: "", ort: "", geburtsdatum: "",
  });

  const load = async () => {
    const r = await api.get("/mandanten");
    setRows(r.data);
  };
  useEffect(() => { load(); }, []);

  const save = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      await api.post("/mandanten", form);
      toast.success("Mandant angelegt");
      setOpen(false);
      setForm({ vorname: "", nachname: "", email: "", telefon: "", strasse: "", plz: "", ort: "", geburtsdatum: "" });
      load();
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Fehler");
    } finally { setSaving(false); }
  };

  const del = async (id) => {
    if (!window.confirm("Mandant löschen?")) return;
    await api.delete(`/mandanten/${id}`);
    toast.success("Gelöscht");
    load();
  };

  return (
    <div className="space-y-8" data-testid="mandanten-page">
      <header className="flex flex-wrap items-end justify-between gap-4">
        <div>
          <p className="overline text-[#D32F2F] mb-2">Mandanten</p>
          <h1 className="font-serif text-4xl tracking-tight">{rows.length} Mandant{rows.length === 1 ? "" : "en"}</h1>
        </div>
        <Dialog open={open} onOpenChange={setOpen}>
          <DialogTrigger asChild>
            <Button className="bg-[#1A2238] hover:bg-[#2C3859]" data-testid="new-mandant-btn"><Plus size={16} className="mr-2" /> Neuer Mandant</Button>
          </DialogTrigger>
          <DialogContent className="sm:max-w-lg">
            <DialogHeader><DialogTitle className="font-serif text-2xl">Neuen Mandanten anlegen</DialogTitle></DialogHeader>
            <form onSubmit={save} className="space-y-3">
              <div className="grid grid-cols-2 gap-3">
                <Field label="Vorname" value={form.vorname} onChange={v => setForm(f => ({ ...f, vorname: v }))} required testid="mandant-vorname" />
                <Field label="Nachname" value={form.nachname} onChange={v => setForm(f => ({ ...f, nachname: v }))} required testid="mandant-nachname" />
              </div>
              <Field label="E-Mail" type="email" value={form.email} onChange={v => setForm(f => ({ ...f, email: v }))} testid="mandant-email" />
              <Field label="Telefon" value={form.telefon} onChange={v => setForm(f => ({ ...f, telefon: v }))} testid="mandant-telefon" />
              <Field label="Straße & Hausnummer" value={form.strasse} onChange={v => setForm(f => ({ ...f, strasse: v }))} testid="mandant-strasse" />
              <div className="grid grid-cols-3 gap-3">
                <Field label="PLZ" value={form.plz} onChange={v => setForm(f => ({ ...f, plz: v }))} testid="mandant-plz" />
                <div className="col-span-2"><Field label="Ort" value={form.ort} onChange={v => setForm(f => ({ ...f, ort: v }))} testid="mandant-ort" /></div>
              </div>
              <Field label="Geburtsdatum" type="date" value={form.geburtsdatum} onChange={v => setForm(f => ({ ...f, geburtsdatum: v }))} testid="mandant-gebdatum" />
              <DialogFooter>
                <Button type="submit" disabled={saving} className="bg-[#1A2238] hover:bg-[#2C3859]" data-testid="mandant-submit-btn">{saving ? "Speichern..." : "Mandant anlegen"}</Button>
              </DialogFooter>
            </form>
          </DialogContent>
        </Dialog>
      </header>

      {rows.length === 0 ? (
        <div className="bg-white border border-[#E5E7EB] rounded-lg p-12 text-center">
          <User size={40} weight="duotone" className="mx-auto text-[#9CA3AF]" />
          <p className="font-serif text-2xl mt-4">Keine Mandanten</p>
        </div>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          {rows.map(m => (
            <div key={m.id} className="bg-white border border-[#E5E7EB] rounded-lg p-5 hover:shadow-sm transition-all">
              <div className="flex items-start justify-between">
                <div>
                  <p className="font-serif text-2xl leading-tight">{m.vorname} {m.nachname}</p>
                  {m.email && <p className="text-sm text-[#4B5563] mt-1">{m.email}</p>}
                  {m.telefon && <p className="text-sm text-[#4B5563]">{m.telefon}</p>}
                  {m.ort && <p className="text-xs text-[#9CA3AF] mt-2">{m.strasse}{m.strasse ? ", " : ""}{m.plz} {m.ort}</p>}
                </div>
                <Button variant="ghost" size="sm" onClick={() => del(m.id)} data-testid={`delete-mandant-${m.id}`}><Trash size={14} /></Button>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

function Field({ label, value, onChange, required, type = "text", testid }) {
  return (
    <div>
      <Label className="overline">{label}</Label>
      <Input type={type} value={value} required={required} onChange={e => onChange(e.target.value)} data-testid={testid} />
    </div>
  );
}
